import * as i0 from '@angular/core';
import { Injectable, Component, ViewEncapsulation, Pipe, ViewChild, Directive, NgModule } from '@angular/core';
import * as i2$1 from '@capturum/auth';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i4$1 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1 from '@capturum/ui/api';
import * as i4 from '@ngx-translate/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import * as i5 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
import * as i6 from '@capturum/ui/input';
import { CapturumInputModule } from '@capturum/ui/input';
import * as i4$2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i9 from '@capturum/ui/password';
import { CapturumPasswordModule } from '@capturum/ui/password';
import * as i10 from '@capturum/ui/input-switch';
import { CapturumInputSwitchModule } from '@capturum/ui/input-switch';
import { tap, take, takeUntil, filter } from 'rxjs/operators';
import * as i9$1 from '@capturum/ui/input-code';
import { CapturumInputCodeComponent, CapturumInputCodeModule } from '@capturum/ui/input-code';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { detect } from 'detect-browser';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CapturumFormFieldModule } from '@capturum/ui/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
function LoginComponent_form_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "auth.sign-in.error"), " ");
  }
}
function LoginComponent_form_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 2);
    i0.ɵɵlistener("ngSubmit", function LoginComponent_form_1_Template_form_ngSubmit_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onSubmit());
    });
    i0.ɵɵelementStart(1, "div", 3)(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, LoginComponent_form_1_div_4_Template, 4, 3, "div", 5);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "cap-input", 6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelement(9, "cap-password", 7);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵelement(13, "cap-input-switch", 8);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 9);
    i0.ɵɵelement(16, "cap-button", 10);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementStart(18, "span", 11);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "a", 12);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const config_r1 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(config_r1 == null ? null : config_r1.productName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.loginError);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(7, 17, "auth.sign-in.email"))("placeholder", i0.ɵɵpipeBind1(8, 19, "auth.sign-in.email"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(10, 21, "auth.sign-in.password"))("placeholder", i0.ɵɵpipeBind1(11, 23, "auth.sign-in.password"))("toggleMask", config_r1.displayPassword)("hideIcon", config_r1.displayPassword == null ? null : config_r1.displayPassword.hideIcon)("showIcon", config_r1.displayPassword == null ? null : config_r1.displayPassword.showIcon)("autoCloseTimeout", config_r1.displayPassword == null ? null : config_r1.displayPassword.autoCloseTimeout);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(14, 25, "auth.sign-in.remember"))("styleClass", "switch");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r0.loginBusy)("label", i0.ɵɵpipeBind1(17, 27, "auth.sign-in.button"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 29, "auth.sign-in.or-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 31, "auth.sign-in.password-forgot"), " ");
  }
}
function TwoFactorComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "auth.2fa.sign-in.error"), " ");
  }
}
function TwoFactorComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "form", 2)(2, "div", 3)(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, TwoFactorComponent_div_0_div_5_Template, 4, 3, "div", 5);
    i0.ɵɵelementStart(6, "div", 6)(7, "span", 4);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 7);
    i0.ɵɵelement(11, "cap-input-code", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 9)(13, "cap-button", 10);
    i0.ɵɵlistener("click", function TwoFactorComponent_div_0_Template_cap_button_click_13_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onSubmit());
    });
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 11);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "a", 12);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const config_r1 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(config_r1 == null ? null : config_r1.productName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.loginError);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 11, "auth.2fa." + ctx_r0.controlMethod.value + ".login.subtitle"));
    i0.ɵɵadvance(5);
    i0.ɵɵclassProp("disabled", ctx_r0.formGroup == null ? null : ctx_r0.formGroup.invalid);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(14, 13, "auth.sign-in.button"))("disabled", ctx_r0.formGroup == null ? null : ctx_r0.formGroup.invalid);
    i0.ɵɵattribute("data-test", "login-button");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 15, "auth.sign-in.or-label"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 17, "auth.2fa.button.back-main-page"), " ");
  }
}
function LoginLayoutComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵpipe(1, "cssUrl");
    i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5);
    i0.ɵɵpipe(6, "cssUrl");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵelement(8, "router-outlet");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const config_r2 = ctx.ngIf;
    i0.ɵɵclassMapInterpolate1("login-screen ", (config_r2 == null ? null : config_r2.displayInputsLabel) ? "display" : "hide", "-inputs-label");
    i0.ɵɵstyleProp("background-image", i0.ɵɵpipeBind1(1, 7, config_r2 == null ? null : config_r2.backgroundImageUrl));
    i0.ɵɵadvance(5);
    i0.ɵɵstyleProp("background-image", i0.ɵɵpipeBind1(6, 9, config_r2 == null ? null : config_r2.logoImageUrl));
  }
}
function LoginLayoutComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 9);
    i0.ɵɵelement(3, "i", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 11)(5, "h5", 12);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 13);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 14)(12, "span", 15);
    i0.ɵɵlistener("click", function LoginLayoutComponent_div_2_Template_span_click_12_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.hideNotification());
    });
    i0.ɵɵtext(13, "\xD7");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const notification_r3 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@flyDown", undefined);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 3, notification_r3.summary), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 5, notification_r3.detail), " ");
  }
}
const _c0 = function (a0) {
  return {
    platform: a0
  };
};
function ActivationComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const config_r1 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, "auth.activation.subtitle", i0.ɵɵpureFunction1(4, _c0, config_r1.productName)));
  }
}
var LoginAction = /*#__PURE__*/function (LoginAction) {
  LoginAction["login"] = "login";
  LoginAction["forgot"] = "forgot";
  LoginAction["reset"] = "reset";
  LoginAction["twoFA"] = "2FA";
  LoginAction["activation"] = "activation";
  return LoginAction;
}(LoginAction || {});
class AuthValidators {
  static password(control) {
    return new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$&()*\\-`._+,])[A-Za-z\\d!@#$&*()\\-`._+,]{8,}').test(control.value) ? null : {
      password: true
    };
  }
  static equalsField(field) {
    const result = function (control) {
      const comparisonControl = control.root.get(field);
      if (comparisonControl) {
        if (comparisonControl.value !== control.value) {
          return {
            equalsField: true
          };
        }
      }
      return null;
    };
    return result;
  }
}
class LoginConfig {
  constructor() {
    this.environment = null;
    this.redirectAfterLogin = '/';
    this.defaultLanguage = 'nl';
    this.productName = '';
    this.backgroundImageUrl = '/assets/images/emendis-complete-bg.jpg';
    this.logoImageUrl = '/assets/images/emendis-complete-logo.png';
    this.displayPassword = null;
    this.passwordValidator = AuthValidators.password;
    this.displayInputsLabel = false;
    this.unsupportedBrowsers = [{
      browser: 'ie',
      minimalVersion: null
    }];
  }
}
let LoginService = /*#__PURE__*/(() => {
  class LoginService {
    constructor(config, router, activatedRoute, toastService, translateService, formBuilder) {
      this.config = config;
      this.router = router;
      this.activatedRoute = activatedRoute;
      this.toastService = toastService;
      this.translateService = translateService;
      this.formBuilder = formBuilder;
      this.action = new BehaviorSubject(null);
      this.prePopulateForms();
    }
    setAction(action, success, status = 200) {
      this.action.next({
        action,
        success,
        status
      });
    }
    getAction() {
      return this.action.asObservable();
    }
    onLoginSuccess(response) {
      const isTwoFactorResponse = response?.hasOwnProperty('method');
      if (response && isTwoFactorResponse) {
        // Let AuthService.onSuccessfulLogin() handle the redirect
      } else if (response && !isTwoFactorResponse) {
        this.router.navigate([this.activatedRoute?.snapshot?.queryParamMap?.get('redirectUrl') || this.config.redirectAfterLogin]);
      }
    }
    onLoginFail(response) {}
    onForgotSuccess(response) {
      this.toastService.success(this.translateService.instant('auth.forgot-password.confirmed.title'), this.translateService.instant('auth.forgot-password.confirmed.description'));
      this.router.navigate(['auth/login']);
    }
    onForgotFail(response) {}
    onResetSuccess(response) {
      this.toastService.success(this.translateService.instant('toast.success.title'), this.translateService.instant('detail.item.saved'));
      this.router.navigate(['auth/login']);
    }
    onResetFail(response) {}
    onTwoFactorLoginSuccess(response) {
      if (response) {
        this.router.navigate([this.activatedRoute?.snapshot?.queryParamMap?.get('redirectUrl') || this.config.redirectAfterLogin]);
      }
    }
    onTwoFactorLoginFail(response) {}
    prePopulateForms() {
      this.loginForm = this.formBuilder.group({
        email: [null, Validators.compose([Validators.required, Validators.email])],
        password: [null, Validators.required],
        remember: [false]
      });
      this.resetForm = this.formBuilder.group({
        email: [null, Validators.compose([Validators.required, Validators.email])],
        password: [null, Validators.compose([Validators.required, this.config.passwordValidator])],
        password_confirmation: [null, Validators.compose([Validators.required, AuthValidators.equalsField('password')])]
      });
      this.forgotForm = this.formBuilder.group({
        email: [null, Validators.compose([Validators.required, Validators.email])]
      });
    }
    static {
      this.ɵfac = function LoginService_Factory(t) {
        return new (t || LoginService)(i0.ɵɵinject(LoginConfig), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i2.ActivatedRoute), i0.ɵɵinject(i1.ToastService), i0.ɵɵinject(i4.TranslateService), i0.ɵɵinject(i4$1.FormBuilder));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LoginService,
        factory: LoginService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LoginService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ForgotPasswordComponent = /*#__PURE__*/(() => {
  class ForgotPasswordComponent {
    constructor(authService, loginService) {
      this.authService = authService;
      this.loginService = loginService;
      this.loading = false;
      this.emailError = false;
      this.resetError = false;
      this.resetSuccess = false;
    }
    ngOnInit() {
      this.createForm();
    }
    /**
     * Submit request a new password form
     */
    onSubmit() {
      if (this.loading) {
        return;
      }
      this.emailError = false;
      this.resetError = false;
      this.resetSuccess = false;
      if (this.form.valid) {
        this.loading = true;
        const {
          email
        } = this.form.value;
        this.authService.recoverPassword(email).subscribe(response => {
          this.loginService.setAction(LoginAction.forgot, true);
          this.loginService.onForgotSuccess(response);
          if (response) {
            this.resetError = false;
            this.resetSuccess = true;
          }
        }, error => {
          this.loginService.setAction(LoginAction.forgot, false);
          this.loginService.onForgotFail(error);
          this.resetError = true;
          this.loading = false;
        });
      } else {
        // Show login error message
        this.emailError = true;
      }
    }
    /**
     * Create fields for login form
     */
    createForm() {
      this.form = this.loginService.forgotForm;
    }
    static {
      this.ɵfac = function ForgotPasswordComponent_Factory(t) {
        return new (t || ForgotPasswordComponent)(i0.ɵɵdirectiveInject(i2$1.AuthService), i0.ɵɵdirectiveInject(LoginService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ForgotPasswordComponent,
        selectors: [["cap-forgot-password"]],
        decls: 24,
        vars: 29,
        consts: [[1, "col-12"], [1, "login-form", 3, "formGroup", "hidden", "ngSubmit"], [1, "title"], [1, "text"], [1, "subtitle"], [1, "alert", "alert-success", 3, "hidden"], [1, "alert", "alert-danger", 3, "hidden"], ["formControlName", "email", "data-test", "email", 3, "label", "placeholder"], [1, "flex-buttons"], ["styleClass", "secondary", "routerLink", "/auth/login", "type", "button", "data-test", "back-button", 3, "label"], ["styleClass", "primary", "type", "submit", "data-test", "reset-password-button", 3, "label", "disabled"]],
        template: function ForgotPasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "form", 1);
            i0.ɵɵlistener("ngSubmit", function ForgotPasswordComponent_Template_form_ngSubmit_1_listener() {
              return ctx.onSubmit();
            });
            i0.ɵɵelementStart(2, "div", 2)(3, "span", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 4)(7, "span", 3);
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "div", 5);
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "div", 6);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(16, "cap-input", 7);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementStart(19, "div", 8);
            i0.ɵɵelement(20, "cap-button", 9);
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelement(22, "cap-button", 10);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formGroup", ctx.form)("hidden", ctx.resetSuccess);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 13, "auth.forgot-password.title"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 15, "auth.forgot-password.description"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", !ctx.resetSuccess);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 17, "auth.forgot-password.confirmed.description"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", !ctx.resetError);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 19, "auth.forgot-password.error"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(17, 21, "auth.forgot-password.email"))("placeholder", i0.ɵɵpipeBind1(18, 23, "auth.forgot-password.email"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(21, 25, "auth.forgot-password.button.back"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(23, 27, "auth.reset-password.submit"))("disabled", ctx.loading);
          }
        },
        dependencies: [i4$1.ɵNgNoValidate, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.FormGroupDirective, i4$1.FormControlName, i2.RouterLink, i5.CapturumButtonComponent, i6.CapturumInputComponent, i4.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return ForgotPasswordComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoginConfigService = /*#__PURE__*/(() => {
  class LoginConfigService {
    constructor(config) {
      this.config = config;
      this.config$ = new BehaviorSubject(this.config);
    }
    /**
     * Get the config as observable
     *
     * @return Observable<LoginConfig>
     */
    getConfig() {
      return this.config$.asObservable();
    }
    /**
     * Set the config
     *
     * @param config: Partial<LoginConfig>
     * @return void
     */
    setConfig(config) {
      this.config$.next({
        ...this.config,
        ...config
      });
    }
    static {
      this.ɵfac = function LoginConfigService_Factory(t) {
        return new (t || LoginConfigService)(i0.ɵɵinject(LoginConfig));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LoginConfigService,
        factory: LoginConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LoginConfigService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoginComponent = /*#__PURE__*/(() => {
  class LoginComponent {
    constructor(configService, authService, loginService) {
      this.configService = configService;
      this.authService = authService;
      this.loginService = loginService;
      this.loginError = false;
      this.loginBusy = false;
    }
    ngOnInit() {
      this.config$ = this.configService.getConfig();
      this.createForm();
    }
    /**
     * Submit login form
     */
    onSubmit() {
      if (this.loginBusy) {
        return;
      }
      this.loginError = false;
      if (this.form.valid) {
        this.loginBusy = true;
        const lastFetchDate = localStorage.getItem('last_data_fetched_at');
        const {
          email,
          password,
          remember
        } = this.form.value;
        let options = {
          remember
        };
        if (lastFetchDate) {
          options = {
            ...options,
            last_data_fetched_at: lastFetchDate
          };
        }
        this.authService.login(email, password, options).subscribe(response => {
          this.loginService.setAction(LoginAction.login, true);
          this.loginService.onLoginSuccess(response);
        }, error => {
          this.loginService.setAction(LoginAction.login, false, error.status);
          this.loginService.onLoginFail(error);
          this.loginError = true;
          this.loginBusy = false;
        });
      }
    }
    /**
     * Create fields for login form
     */
    createForm() {
      this.form = this.loginService.loginForm;
    }
    static {
      this.ɵfac = function LoginComponent_Factory(t) {
        return new (t || LoginComponent)(i0.ɵɵdirectiveInject(LoginConfigService), i0.ɵɵdirectiveInject(i2$1.AuthService), i0.ɵɵdirectiveInject(LoginService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginComponent,
        selectors: [["cap-login"]],
        decls: 3,
        vars: 3,
        consts: [[1, "col-12", "login-container"], ["class", "login-form", 3, "formGroup", "ngSubmit", 4, "ngIf"], [1, "login-form", 3, "formGroup", "ngSubmit"], [1, "title"], [1, "text"], [4, "ngIf"], ["formControlName", "email", "styleClass", "w-100", "data-test", "email", 3, "label", "placeholder"], ["formControlName", "password", "styleClass", "w-100", 3, "label", "placeholder", "toggleMask", "hideIcon", "showIcon", "autoCloseTimeout"], ["formControlName", "remember", "data-test", "remember-switch", 3, "label", "styleClass"], [1, "login-actions", "d-flex", "align-items-center"], ["type", "submit", "styleClass", "primary", "data-test", "login-button", 3, "disabled", "label"], [1, "login-separator"], ["routerLink", "/auth/forgot-password", "data-test", "forgot-password-link", 1, "login-link"], ["data-test", "login-alert", 1, "alert", "alert-danger"]],
        template: function LoginComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, LoginComponent_form_1_Template, 24, 33, "form", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx.config$));
          }
        },
        dependencies: [i4$2.NgIf, i4$1.ɵNgNoValidate, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.FormGroupDirective, i4$1.FormControlName, i2.RouterLink, i5.CapturumButtonComponent, i6.CapturumInputComponent, i9.CapturumPasswordComponent, i10.CapturumInputSwitchComponent, i4$2.AsyncPipe, i4.TranslatePipe],
        styles: ["body cap-input-switch .form-element{display:flex;align-items:flex-start;margin-bottom:10px;margin-top:20px}body .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider{background-color:#35c44d}body .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider:hover{background-color:#35c44d!important}body .p-inputswitch .p-inputswitch-slider:before{margin-top:-8px}.w-100{width:100%}\n"],
        encapsulation: 2
      });
    }
  }
  return LoginComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CssUrlPipe = /*#__PURE__*/(() => {
  class CssUrlPipe {
    /**
     * Make an CSS url out of string path
     *
     * @param path: string
     * @return string
     */
    transform(path) {
      return path ? `url(${path})` : path;
    }
    static {
      this.ɵfac = function CssUrlPipe_Factory(t) {
        return new (t || CssUrlPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cssUrl",
        type: CssUrlPipe,
        pure: true
      });
    }
  }
  return CssUrlPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ResetPasswordComponent = /*#__PURE__*/(() => {
  class ResetPasswordComponent {
    constructor(route, authService, loginService) {
      this.route = route;
      this.authService = authService;
      this.loginService = loginService;
      this.emailError = false;
      this.resetError = false;
      this.resetSuccess = false;
    }
    ngOnInit() {
      this.createForm();
      this.route.params.subscribe(params => {
        if (params.token) {
          this.token = params.token;
        }
        if (params.email) {
          this.form.patchValue({
            email: params.email
          });
          this.form.get('email').disable();
          this.form.get('email').updateValueAndValidity();
        }
      });
    }
    submit() {
      this.emailError = false;
      this.resetError = false;
      this.resetSuccess = false;
      for (const key in this.form.controls) {
        if (this.form.get(key)) {
          this.form.get(key).markAsTouched();
        }
      }
      if (this.form.valid) {
        this.form.get('email').enable();
        const {
          email,
          password,
          password_confirmation
        } = this.form.value;
        this.authService.resetPassword({
          token: this.token,
          email,
          password,
          password_confirmation
        }).subscribe(response => {
          this.loginService.setAction(LoginAction.reset, true);
          this.loginService.onResetSuccess(response);
          this.resetSuccess = true;
        }, error => {
          this.loginService.setAction(LoginAction.reset, false);
          this.resetError = true;
          this.loginService.onResetFail(error);
        });
      } else {
        this.emailError = true;
      }
    }
    /**
     * Create fields for reset password form
     */
    createForm() {
      this.form = this.loginService.resetForm;
    }
    static {
      this.ɵfac = function ResetPasswordComponent_Factory(t) {
        return new (t || ResetPasswordComponent)(i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2$1.AuthService), i0.ɵɵdirectiveInject(LoginService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ResetPasswordComponent,
        selectors: [["cap-reset-password"]],
        decls: 30,
        vars: 40,
        consts: [[1, "col-12"], [1, "alert", "alert-success", 3, "hidden"], [1, "login-form", 3, "formGroup", "hidden", "ngSubmit"], [1, "title"], [1, "text"], [1, "subtitle"], [1, "alert", "alert-danger", 3, "hidden"], ["formControlName", "email", 3, "label", "placeholder"], ["formControlName", "password", "type", "password", 3, "label", "placeholder"], ["formControlName", "password_confirmation", "type", "password", 3, "label", "placeholder"], [1, "flex-buttons"], ["type", "button", "routerLink", "/auth/login", "styleClass", "secondary", 3, "label"], ["type", "submit", "styleClass", "primary", 3, "label"]],
        template: function ResetPasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "form", 2);
            i0.ɵɵlistener("ngSubmit", function ResetPasswordComponent_Template_form_ngSubmit_4_listener() {
              return ctx.submit();
            });
            i0.ɵɵelementStart(5, "div", 3)(6, "span", 4);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 5)(10, "span", 4);
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 6);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(16, "cap-input", 7);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelement(19, "cap-input", 8);
            i0.ɵɵpipe(20, "translate");
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelement(22, "cap-input", 9);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵpipe(24, "translate");
            i0.ɵɵelementStart(25, "div", 10);
            i0.ɵɵelement(26, "cap-button", 11);
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵelement(28, "cap-button", 12);
            i0.ɵɵpipe(29, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("hidden", !ctx.resetSuccess);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 16, "auth.reset-password.success"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.form)("hidden", ctx.resetSuccess);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 18, "auth.reset-password.title"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 20, "auth.reset-password.subtitle"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", !ctx.resetError);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 22, "auth.reset-password.error"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(17, 24, "auth.sign-in.email"))("placeholder", i0.ɵɵpipeBind1(18, 26, "auth.sign-in.email"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(20, 28, "auth.reset-password.password"))("placeholder", i0.ɵɵpipeBind1(21, 30, "auth.reset-password.password"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(23, 32, "auth.reset-password.confirm-password"))("placeholder", i0.ɵɵpipeBind1(24, 34, "auth.reset-password.confirm-password"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(27, 36, "auth.forgot-password.button.back"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(29, 38, "auth.reset-password.submit"));
          }
        },
        dependencies: [i4$1.ɵNgNoValidate, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.FormGroupDirective, i4$1.FormControlName, i2.RouterLink, i5.CapturumButtonComponent, i6.CapturumInputComponent, i4.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return ResetPasswordComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TwoFactorComponent = /*#__PURE__*/(() => {
  class TwoFactorComponent {
    get controlMethod() {
      return this.formGroup.get('method');
    }
    constructor(configService, route, twoFactorAuthService, formBuilder, translateService, loginService) {
      this.configService = configService;
      this.route = route;
      this.twoFactorAuthService = twoFactorAuthService;
      this.formBuilder = formBuilder;
      this.translateService = translateService;
      this.loginService = loginService;
      this.loginError = false;
    }
    ngOnInit() {
      this.config$ = this.configService.getConfig().pipe(tap(config => this.translateService.use(config.defaultLanguage)));
      this.formGroup = this.generateForm();
    }
    generateForm() {
      const {
        userId,
        method
      } = this.route.snapshot.queryParams;
      return this.formBuilder.group({
        key: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
        user_id: [userId, Validators.required],
        method: [method, Validators.required]
      });
    }
    onSubmit() {
      this.loginError = false;
      this.twoFactorAuthService.login(this.formGroup.value).subscribe({
        next: response => {
          this.loginService.setAction(LoginAction.twoFA, true);
          this.loginService.onTwoFactorLoginSuccess(response);
        },
        error: error => {
          this.loginError = true;
          this.loginService.setAction(LoginAction.login, false, error.status);
          this.loginService.onTwoFactorLoginFail(error);
          this.inputCodeComponent.reset();
        }
      });
    }
    static {
      this.ɵfac = function TwoFactorComponent_Factory(t) {
        return new (t || TwoFactorComponent)(i0.ɵɵdirectiveInject(LoginConfigService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2$1.TwoFactorAuthService), i0.ɵɵdirectiveInject(i4$1.FormBuilder), i0.ɵɵdirectiveInject(i4.TranslateService), i0.ɵɵdirectiveInject(LoginService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TwoFactorComponent,
        selectors: [["cap-two-factor"]],
        viewQuery: function TwoFactorComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CapturumInputCodeComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputCodeComponent = _t.first);
          }
        },
        decls: 2,
        vars: 3,
        consts: [["class", "col-12", 4, "ngIf"], [1, "col-12"], [1, "login-form", 3, "formGroup"], [1, "title", "mb-0"], [1, "text"], [4, "ngIf"], [1, "subtitle"], [1, "mb-4", "mx-auto", "mx-md-0"], ["formControlName", "key"], [1, "login-actions", "d-flex", "align-items-center"], ["type", "button", "styleClass", "primary", 3, "label", "disabled", "click"], [1, "login-separator"], ["routerLink", "/auth/login", "data-test", "forgot-password-link", 1, "login-link"], ["data-test", "login-alert", 1, "alert", "alert-danger"]],
        template: function TwoFactorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TwoFactorComponent_div_0_Template, 21, 19, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.config$));
          }
        },
        dependencies: [i4$2.NgIf, i4$1.ɵNgNoValidate, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.FormGroupDirective, i4$1.FormControlName, i2.RouterLink, i5.CapturumButtonComponent, i9$1.CapturumInputCodeComponent, i4$2.AsyncPipe, i4.TranslatePipe],
        styles: [".login-form[_ngcontent-%COMP%]   cap-input-switch[_ngcontent-%COMP%]{display:none}.login-form[_ngcontent-%COMP%]   .form-element[_ngcontent-%COMP%]{margin-bottom:15px}.login-form[_ngcontent-%COMP%]   .form-element[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:none}.login-form[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:26px;font-weight:500;font-family:NeoSansW1G-Medium,sans-serif;margin-bottom:30px}.login-form[_ngcontent-%COMP%]   .login-actions[_ngcontent-%COMP%]   span.login-separator[_ngcontent-%COMP%]{color:#e1e1e1;font-size:14px;font-weight:600}.inputs-code[_ngcontent-%COMP%]{display:flex}.inputs-code[_ngcontent-%COMP%]     .input-code{font-size:22px;height:37px;max-width:38px;font-weight:600;margin-right:10px}.inputs-code[_ngcontent-%COMP%]     .input-code.p-inputtext:hover, .inputs-code[_ngcontent-%COMP%]     .input-code.p-inputtext:enabled:hover:not(.p-state-error), .inputs-code[_ngcontent-%COMP%]     .input-code.p-inputtext:enabled:focus:not(.p-state-error){font-size:22px;height:37px}@media screen and (max-width: 400px){.inputs-code[_ngcontent-%COMP%]     .input-code{margin-right:5px;max-width:35px}}.inputs-code[_ngcontent-%COMP%]     cap-validator{display:none}"]
      });
    }
  }
  return TwoFactorComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoginLayoutComponent = /*#__PURE__*/(() => {
  class LoginLayoutComponent {
    constructor(validationService, configService, translateService) {
      this.validationService = validationService;
      this.configService = configService;
      this.translateService = translateService;
      this.notificationSubject$ = new BehaviorSubject(null);
      this.translateService.setDefaultLang('nl');
      this.config$ = this.configService.getConfig().pipe(tap(config => {
        this.translateService.use(config.defaultLanguage);
      }));
      this.validationService.setValidationMessages({
        required: 'validation-errors.required',
        password: 'validation-errors.password.general',
        equalsField: 'auth.reset-password.mismatch.message',
        email: 'validation-errors.email'
      });
      this.browser = detect();
      this.detectUnsupportedBrowser();
    }
    hideNotification() {
      this.notificationSubject$.next(null);
    }
    detectUnsupportedBrowser() {
      this.config$.pipe(take(1)).subscribe(config => {
        if (this.isUnSupportedBrowser(config)) {
          this.notificationSubject$.next({
            summary: 'auth.outdated-browser.summary',
            detail: 'auth.outdated-browser.detail'
          });
        }
      });
    }
    isUnSupportedBrowser(config) {
      if (!this.browser) {
        return true;
      }
      const {
        unsupportedBrowsers
      } = config;
      const browserName = this.browser.name;
      const browserVersion = +this.browser.version?.split('.')?.[0];
      return unsupportedBrowsers.some(unsupportedBrowser => {
        return unsupportedBrowser.browser === browserName && (unsupportedBrowser.minimalVersion >= browserVersion || !unsupportedBrowser.minimalVersion);
      });
    }
    static {
      this.ɵfac = function LoginLayoutComponent_Factory(t) {
        return new (t || LoginLayoutComponent)(i0.ɵɵdirectiveInject(i1.ValidatorService), i0.ɵɵdirectiveInject(LoginConfigService), i0.ɵɵdirectiveInject(i4.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginLayoutComponent,
        selectors: [["cap-login"]],
        decls: 4,
        vars: 6,
        consts: [[3, "class", "background-image", 4, "ngIf"], ["class", "notifications-container", 4, "ngIf"], [1, "login-wrapper"], [1, "content-wrapper", "row"], [1, "content-left", "col-12", "col-md-5"], ["data-test", "logo", 1, "logo"], [1, "content-right", "col-12", "col-md-7"], [1, "notifications-container"], [1, "notification", "warning"], [1, "icon"], [1, "fas", "fa-exclamation-triangle"], [1, "description"], [1, "header"], [1, "message"], [1, "action"], [1, "close-click", 3, "click"]],
        template: function LoginLayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, LoginLayoutComponent_div_0_Template, 9, 11, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, LoginLayoutComponent_div_2_Template, 14, 7, "div", 1);
            i0.ɵɵpipe(3, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.config$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.notificationSubject$));
          }
        },
        dependencies: [i4$2.NgIf, i2.RouterOutlet, i4$2.AsyncPipe, i4.TranslatePipe, CssUrlPipe],
        styles: [".login-wrapper{position:absolute;width:80%;left:10%;right:10%;top:10%}@media (min-width: 768px){.login-wrapper{top:50%;width:100%;left:auto;right:auto}}@media (max-width: 575.98px){.login-wrapper{right:30px;left:29px;width:unset}}.content-wrapper{position:relative;margin:0 auto;height:100%;max-width:843px;overflow:hidden;border-radius:6px;box-shadow:#0000001a 0 5px 13px}@media (min-width: 768px){.content-wrapper{margin-top:-200px;min-width:280px;height:auto}.content-wrapper .content-right{padding:40px}}@media (max-width: 575.98px){.content-wrapper{border-radius:3px;box-shadow:0 5px 13px #00000040}}.content-wrapper .content-left{padding:15px;height:auto;text-align:center;background:#fff;justify-content:center;align-items:center;display:flex;flex-direction:column;border-bottom:1px solid rgba(112,112,112,.1)}@media (min-width: 768px){.content-wrapper .content-left{border-right:1px solid rgba(112,112,112,.1);border-bottom:none;padding:30px}}@media (max-width: 575.98px){.content-wrapper .content-left{max-height:77px}}.content-wrapper .content-left div.logo{background-size:contain;background-position:center;background-repeat:no-repeat;width:100%;height:100px;max-width:264px}@media (min-width: 768px){.content-wrapper .content-left div.logo{height:150px}}.content-wrapper .content-left .login-text{padding:10px 0;color:#fff}.password-instructions{font-size:13px}.content-right{height:100%;vertical-align:top;background:#fff}@media (min-width: 768px){.content-right{padding:40px}}@media (max-width: 767.98px){.content-right .ui-button.em-button{font-size:13px;padding:2px 10px}}@media (max-width: 575.98px){.content-right .login-container{padding-top:19px;padding-bottom:30px}}.content-right .subtitle{padding:25px 0}.content-right .subtitle .text{font-size:14px;color:#97979a}.content-right input{outline:none}.content-right .cap-form-field-validator{display:none}.content-right cap-validator .validator{margin-top:0}.content-right .login-form{display:flex;flex-direction:column;justify-content:center}@media (min-width: 576px){.content-right .login-form{min-height:360px}}.content-right .login-form>div{margin:5px 0}.content-right .login-form .title{margin-bottom:28px}.content-right .login-form .login-actions .login-separator{font-size:15px;font-weight:600;color:var(--third-color);margin:auto 20px}@media (max-width: 767.98px){.content-right .login-form .login-actions .login-separator{margin:auto 10px}}.content-right .login-form .login-actions .login-link{display:inline-block;font-size:14px;font-weight:300;color:var(--primary-color);text-decoration:underline}.content-right .login-form .login-actions .login-link:hover{text-decoration:none}@media (max-width: 575.98px){.content-right .login-form .login-actions .login-link{font-family:SourceSansPro-Regular,sans-serif;font-size:13px;height:17px}}@media (max-width: 575.98px){.content-right .login-form .login-actions cap-button p-button .cap-button{height:30px}.content-right .login-form .login-actions cap-button p-button span.p-button-label{align-items:center;padding:0}}@media (max-width: 575.98px){.content-right .login-form cap-input-switch .form-element{display:flex;align-items:center;padding-top:17px;padding-bottom:14px}}.login-screen{width:100%;height:100vh;background-size:cover}.alert{padding:10px;border-radius:5px;font-size:16px;font-weight:600}.alert.alert-danger{border:1px solid var(--error-color);background:var(--error-color-shadow);color:var(--error-color)}.alert.alert-success{border:1px solid var(--success-color);background:var(--success-color-shadow);color:var(--success-color)}.flex-buttons{display:flex;flex-direction:column}@media (min-width: 576px){.flex-buttons{display:flex;justify-content:space-between;flex-direction:row}.flex-buttons p-button{width:100%}.flex-buttons cap-button:first-of-type{order:2}.flex-buttons cap-button:last-of-type{order:1}.flex-buttons cap-button:last-of-type .cap-button{margin-bottom:15px}}.flex-buttons cap-button:first-of-type{order:1}.flex-buttons cap-button:last-of-type{order:2}.flex-buttons cap-button:first-of-type .cap-button{margin-bottom:15px}.flex-buttons cap-button p-button,.flex-buttons cap-button .cap-button{width:100%}.hide-inputs-label cap-input .form-element label{display:none}.display-inputs-label cap-input .form-element label{display:block}.notifications-container{position:fixed;top:0;right:0;left:0;line-height:25px;width:100%;z-index:6;overflow:hidden}.notifications-container .notification{position:relative;text-align:center;font-size:12px;color:#fff;display:flex;align-items:center}.notifications-container .message{padding:0 12px}.notifications-container .warning{background-color:#ffc107;border-bottom:1px solid #ffc107}.notifications-container .icon,.notifications-container .action{padding-left:1rem;padding-right:1rem;color:#fff;font-size:1.4rem}.notifications-container .description{flex:1;padding-top:.5rem;padding-bottom:.5rem}.notifications-container .header{margin:0;font-size:1.2rem}.notifications-container .close-click{font-size:22px;cursor:pointer;padding:10px;position:relative;top:2px;margin:0 auto}.title .text{font-size:28px;font-weight:700;color:#424242}@media (max-width: 575.98px){.title .text{color:#333;font-size:20px}}\n"],
        encapsulation: 2,
        data: {
          animation: [trigger('flyDown', [state('in', style({
            opacity: 1,
            transform: 'translateY(0)'
          })), transition('void => *', [style({
            opacity: 0,
            transform: 'translateY(-100%)'
          }), animate('600ms ease-in')]), transition('* => void', [animate('200ms ease-out', style({
            opacity: 0,
            transform: 'translateY(-100%)'
          }))]), transition(':leave', [animate('200ms ease-out', style({
            opacity: 0,
            transform: 'translateY(-100%)'
          }))])])]
        }
      });
    }
  }
  return LoginLayoutComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthPageBase = /*#__PURE__*/(() => {
  class AuthPageBase {
    constructor(validatorService) {
      this.validatorService = validatorService;
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.fetchBackendErrors();
    }
    ngOnDestroy() {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
    markAsTouched() {
      for (const key in this.form.controls) {
        if (this.form.get(key)) {
          this.form.get(key).markAsTouched();
        }
      }
    }
    fetchBackendErrors() {
      this.validatorService?.backendValidation$.pipe(takeUntil(this.destroy$), filter(Boolean)).subscribe(errors => {
        this.validatorService.setBackendErrorsOnForm(this.form, errors);
      });
    }
    static {
      this.ɵfac = function AuthPageBase_Factory(t) {
        return new (t || AuthPageBase)(i0.ɵɵdirectiveInject(i1.ValidatorService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AuthPageBase
      });
    }
  }
  return AuthPageBase;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumActivationService = /*#__PURE__*/(() => {
  class CapturumActivationService {
    constructor(config, router, toastService, translateService, formBuilder) {
      this.config = config;
      this.router = router;
      this.toastService = toastService;
      this.translateService = translateService;
      this.formBuilder = formBuilder;
    }
    onSuccess(response) {
      this.toastService.success(this.translateService.instant('auth.activation.title'), this.translateService.instant('auth.activation.success'));
      this.router.navigate(['auth/login']);
    }
    onFail(error) {}
    getForm() {
      return this.formBuilder.group({
        email: [null, Validators.compose([Validators.required, Validators.email])],
        password: [null, Validators.compose([Validators.required, this.config.passwordValidator])],
        password_confirmation: [null, Validators.compose([Validators.required, AuthValidators.equalsField('password')])]
      });
    }
    static {
      this.ɵfac = function CapturumActivationService_Factory(t) {
        return new (t || CapturumActivationService)(i0.ɵɵinject(LoginConfig), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i1.ToastService), i0.ɵɵinject(i4.TranslateService), i0.ɵɵinject(i4$1.FormBuilder));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CapturumActivationService,
        factory: CapturumActivationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CapturumActivationService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ActivationComponent = /*#__PURE__*/(() => {
  class ActivationComponent extends AuthPageBase {
    constructor(validatorService, activationService, route, configService, authService) {
      super(validatorService);
      this.validatorService = validatorService;
      this.activationService = activationService;
      this.route = route;
      this.configService = configService;
      this.authService = authService;
      this.action = LoginAction.activation;
      this.config$ = this.configService.getConfig();
      this.form = this.activationService.getForm();
    }
    ngOnInit() {
      super.ngOnInit();
      this.route.params.pipe(take(1)).subscribe(params => {
        if (params.token) {
          this.token = params.token;
        }
        if (params.email) {
          this.form.patchValue({
            email: params.email
          });
          this.form.get('email').disable();
          this.form.get('email').updateValueAndValidity();
        }
      });
    }
    submit() {
      if (this.form.invalid) {
        this.markAsTouched();
        return;
      }
      this.authService.activate({
        token: this.token,
        ...this.form.getRawValue()
      }).subscribe(response => this.activationService.onSuccess(response), error => this.activationService.onFail(error));
    }
    static {
      this.ɵfac = function ActivationComponent_Factory(t) {
        return new (t || ActivationComponent)(i0.ɵɵdirectiveInject(i1.ValidatorService), i0.ɵɵdirectiveInject(CapturumActivationService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(LoginConfigService), i0.ɵɵdirectiveInject(i2$1.AuthService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ActivationComponent,
        selectors: [["cap-activation"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 22,
        vars: 31,
        consts: [[1, "col-12"], [1, "login-form", 3, "formGroup", "ngSubmit"], [1, "title"], [1, "text"], ["class", "subtitle", 4, "ngIf"], ["formControlName", "email", 3, "label", "placeholder"], ["formControlName", "password", "type", "password", 3, "label", "placeholder"], ["formControlName", "password_confirmation", "type", "password", 3, "label", "placeholder"], [1, "flex-buttons"], ["routerLink", "/auth/login", "styleClass", "secondary", "type", "button", 3, "label"], ["styleClass", "primary", "type", "submit", 3, "label"], [1, "subtitle"]],
        template: function ActivationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "form", 1);
            i0.ɵɵlistener("ngSubmit", function ActivationComponent_Template_form_ngSubmit_1_listener() {
              return ctx.submit();
            });
            i0.ɵɵelementStart(2, "div", 2)(3, "span", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, ActivationComponent_div_6_Template, 4, 6, "div", 4);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵelement(8, "cap-input", 5);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelement(11, "cap-input", 6);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵelement(14, "cap-input", 7);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵpipe(16, "translate");
            i0.ɵɵelementStart(17, "div", 8);
            i0.ɵɵelement(18, "cap-button", 9);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵelement(20, "cap-button", 10);
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 11, "auth.activation.title"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 13, ctx.config$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(9, 15, "auth.username.label"))("placeholder", i0.ɵɵpipeBind1(10, 17, "auth.username.placeholder"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(12, 19, "auth.activation.password.label"))("placeholder", i0.ɵɵpipeBind1(13, 21, "auth.password.placeholder"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(15, 23, "auth.activation.confirm-password.label"))("placeholder", i0.ɵɵpipeBind1(16, 25, "auth.password-confirmation.placeholder"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(19, 27, "auth.forgot-password.button.back"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(21, 29, "auth.activation.submit"));
          }
        },
        dependencies: [i4$2.NgIf, i4$1.ɵNgNoValidate, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.FormGroupDirective, i4$1.FormControlName, i2.RouterLink, i5.CapturumButtonComponent, i6.CapturumInputComponent, i4$2.AsyncPipe, i4.TranslatePipe]
      });
    }
  }
  return ActivationComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SsoLoginResolver = /*#__PURE__*/(() => {
  class SsoLoginResolver {
    constructor(http, config) {
      this.http = http;
      this.config = config;
    }
    resolve() {
      const url = `${this.config.baseUrl}/sso-login`;
      return this.http.get(url).pipe(tap(response => {
        if (response) {
          // Redirect the user to the Microsoft authentication page
          window.location.href = response.url;
        }
      }));
    }
    static {
      this.ɵfac = function SsoLoginResolver_Factory(t) {
        return new (t || SsoLoginResolver)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2$1.AuthConfig));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SsoLoginResolver,
        factory: SsoLoginResolver.ɵfac
      });
    }
  }
  return SsoLoginResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SsoCallbackResolver = /*#__PURE__*/(() => {
  class SsoCallbackResolver {
    constructor(http, authService, config, loginService) {
      this.http = http;
      this.authService = authService;
      this.config = config;
      this.loginService = loginService;
    }
    resolve(route, state) {
      const activeUrl = state.url;
      const azureCredentials = activeUrl.substring(activeUrl.indexOf('?'));
      const url = `${this.config.baseUrl}/sso-callback${azureCredentials}`;
      return this.http.get(url).pipe(tap(result => {
        if (result.status === 'ok') {
          result.sso = true;
          if (result.user) {
            if (result.user.roles !== undefined && result.user.roles.data !== undefined) {
              result.user.roles = result.user.roles.data;
            }
            const user = result.user;
            localStorage.setItem('user', JSON.stringify(user));
          }
          localStorage.setItem('token', result.token);
          if (result.refresh_token) {
            localStorage.setItem('refresh_token', result.refresh_token);
          }
          this.authService.handleSuccessfulLogin(result);
          this.authService.setAuthenticationState(true);
          this.loginService.setAction(LoginAction.login, true);
          this.loginService.onLoginSuccess(result);
        }
      }));
    }
    static {
      this.ɵfac = function SsoCallbackResolver_Factory(t) {
        return new (t || SsoCallbackResolver)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2$1.AuthService), i0.ɵɵinject(i2$1.AuthConfig), i0.ɵɵinject(LoginService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SsoCallbackResolver,
        factory: SsoCallbackResolver.ɵfac
      });
    }
  }
  return SsoCallbackResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const loginRoutes = [{
  path: 'auth',
  component: LoginLayoutComponent,
  children: [{
    path: 'login',
    component: LoginComponent
  }, {
    path: 'login/sso',
    component: LoginComponent,
    resolve: {
      ssoLogin: SsoLoginResolver
    }
  }, {
    path: 'login/sso/callback',
    component: LoginComponent,
    resolve: {
      ssoCallback: SsoCallbackResolver
    }
  }, {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  }, {
    path: 'reset-password/:token/:email',
    component: ResetPasswordComponent
  }, {
    path: 'reset-password/:token',
    component: ResetPasswordComponent
  }, {
    path: 'two-factor',
    component: TwoFactorComponent
  }, {
    path: 'activation/:token/:email',
    component: ActivationComponent
  }]
}];
let LoginRoutingModule = /*#__PURE__*/(() => {
  class LoginRoutingModule {
    static {
      this.ɵfac = function LoginRoutingModule_Factory(t) {
        return new (t || LoginRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LoginRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [SsoLoginResolver, SsoCallbackResolver],
        imports: [RouterModule.forChild([]), RouterModule]
      });
    }
  }
  return LoginRoutingModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function MyHttpLoaderFactory(http) {
  return new TranslateHttpLoader(http);
}
let LoginModule = /*#__PURE__*/(() => {
  class LoginModule {
    static forRoot(loginConfig) {
      const defaultConfig = new LoginConfig();
      const config = {
        ...defaultConfig,
        ...loginConfig
      };
      return {
        ngModule: LoginModule,
        providers: [{
          provide: LoginConfig,
          useValue: config
        }, {
          provide: LoginService,
          useClass: loginConfig.loginService || LoginService
        }, {
          provide: CapturumActivationService,
          useClass: loginConfig.activationService || CapturumActivationService
        }]
      };
    }
    static {
      this.ɵfac = function LoginModule_Factory(t) {
        return new (t || LoginModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LoginModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [MessageService],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, LoginRoutingModule, CapturumButtonModule, CapturumInputModule, CapturumPasswordModule, CapturumFormFieldModule, CapturumInputSwitchModule, HttpClientModule, TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: MyHttpLoaderFactory,
            deps: [HttpClient]
          }
        }), BrowserAnimationsModule, CapturumInputCodeModule]
      });
    }
  }
  return LoginModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of login
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActivationComponent, CssUrlPipe, ForgotPasswordComponent, LoginAction, LoginComponent, LoginConfig, LoginConfigService, LoginLayoutComponent, LoginModule, LoginRoutingModule, LoginService, MyHttpLoaderFactory, ResetPasswordComponent, TwoFactorComponent, loginRoutes };
